import { useTranslation } from 'react-i18next';
import InstacartCarrot from 'src/images/logos/instacart-carrot.svg?react';

type Props = {
  onClick: () => void;
};

/**
 * Instacart Developer Platform dark CTA
 * https://docs.instacart.com/developer_platform_api/guide/concepts/design/cta_design
 */
export const InstacartShopButton = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <button
      type='button'
      onClick={onClick}
      className='inline-flex box-border h-[46px] w-full items-center justify-center gap-2 rounded-[29.5px] px-[18px] font-semibold transition-opacity hover:opacity-90 smMed:w-auto'
      style={{ backgroundColor: '#003D29', color: '#FAF1E5' }}
    >
      <InstacartCarrot
        aria-hidden
        className='h-[22px] w-[22px] shrink-0'
        width={22}
        height={22}
      />
      <span className='whitespace-nowrap text-base leading-none'>
        {t('get.shop_on_instacart')}
      </span>
    </button>
  );
};
